import { customerMarketShopfrontApi, marketApi } from '@envato/foundation-types'
import { MakeSearchLink } from './location/types'

type CTA =
  | customerMarketShopfrontApi.categoryPage.ICta
  | customerMarketShopfrontApi.categoryPage.ISearchCta

interface IUrlFromCTA {
  makeSearchLink: MakeSearchLink
  cta?: CTA
}

export interface ICategory extends marketApi.ICategory {
  number_of_items: number
  children?: ICategory[]
}

export const urlFromCTA = ({ makeSearchLink, cta }: IUrlFromCTA) => {
  if (!cta) {
    return null
  }

  if ((cta as customerMarketShopfrontApi.categoryPage.ICta).url) {
    return (cta as customerMarketShopfrontApi.categoryPage.ICta).url
  }

  if (
    (cta as customerMarketShopfrontApi.categoryPage.ISearchCta).urlSearchParams
  ) {
    const urlSearchParams = (cta as customerMarketShopfrontApi.categoryPage.ISearchCta)
      .urlSearchParams
    return makeSearchLink(urlSearchParams)
  }

  return null
}

export const getCategoriesList = (categories: marketApi.ICategory[]) =>
  categories.reduce<marketApi.ICategory[]>((list, category) => {
    list.push({
      path: category.path,
      name: category.name,
      number_of_items: category.number_of_items
    })

    if (category.children) {
      list.push(...getCategoriesList(category.children))
    }

    return list
  }, [])
